import { FailedEmailsPage } from '@/features/emails/FailedEmailsPage';
import { Navigate, useParams, useSearchParams, type RouteObject } from 'react-router';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { InboxPage } from '@/features/cases/InboxPage';
import { ArchivePage } from '@/features/cases/ArchivePage';
import { NewCasePage } from '@/features/cases/NewCasePage';
import { CaseDetailPage } from '@/features/cases/CaseDetailPage';
import { TasksPage } from '@/features/tasks/TasksPage';
import { TaskDetailPage } from '@/features/tasks/TaskDetailPage';
import { QueuesPage } from '@/features/assignments/QueuesPage';
import { UnassignedQueuePage } from '@/features/assignments/UnassignedQueuePage';
import { CitizenPage } from '@/features/citizens/CitizenPage';
import { CitizensPage } from '@/features/citizens/CitizensPage';
import { ProfilePage } from '@/features/profile/ProfilePage';

/** Enlaces anteriores a la ficha (antes «Ciudadanos», hoy «Directorio»). */
function CitizensRedirect() { return <Navigate to={`/directorio/${useParams().id ?? ''}`} replace />; }
/** Enlaces anteriores a «Apoyos» (antes en el menú): los por responder son tareas, los enviados una pestaña de «Mis tareas». */
function SupportRedirect() { return <Navigate to={useSearchParams()[0].get('bandeja') === 'enviadas' ? '/tareas?vista=apoyos-enviados' : '/tareas'} replace />; }

/** Operations area routes (dashboard, inbox, expediente, tasks, queues, directory, profile). */
export const operationsRoutes: RouteObject[] = [
  { index: true, element: <DashboardPage /> },
  { path: 'pqrs', element: <InboxPage /> },
  { path: 'pqrs/nueva', element: <NewCasePage /> },
  { path: 'pqrs/:id', element: <CaseDetailPage /> },
  { path: 'archivo', element: <ArchivePage /> },
  { path: 'expedientes', element: <Navigate to="/archivo" replace /> },
  { path: 'tareas', element: <TasksPage /> },
  { path: 'correos-no-enviados', element: <FailedEmailsPage /> },
  { path: 'tareas/:id', element: <TaskDetailPage /> },
  { path: 'apoyos', element: <SupportRedirect /> },
  { path: 'asignacion', element: <QueuesPage /> },
  { path: 'asignacion/sin-asignar', element: <UnassignedQueuePage /> },
  { path: 'directorio', element: <CitizensPage /> },
  { path: 'directorio/:id', element: <CitizenPage /> },
  { path: 'ciudadanos', element: <Navigate to="/directorio" replace /> },
  { path: 'ciudadanos/:id', element: <CitizensRedirect /> },
  { path: 'perfil', element: <ProfilePage /> },
];
